var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
var locals_ = (locals || {}),max = locals_.max,prev = locals_.prev,links = locals_.links,current = locals_.current,next = locals_.next;
var jade_indent = [];
if (max > 1)
{
buf.push("\n<ul class=\"pagination\">\n  <li" + (jade.cls(["" + (prev ? '' : 'disabled') + ""], [true])) + ">");
if (prev)
{
buf.push("<a" + (jade.attr("href", "" + (prev) + "", true, false)) + "><span class=\"fa fa-caret-left\"></span></a>");
}
else
{
buf.push("<a href=\"javascript: void(0);\"><span class=\"fa fa-caret-left\"></span></a>");
}
buf.push("\n  </li>");
// iterate links
;(function(){
  var $$obj = links;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var link = $$obj[$index];

buf.push("\n  <li" + (jade.cls(["" + (link.text == current ? 'active' : '') + ""], [true])) + ">");
if (link.href)
{
buf.push("<a" + (jade.attr("href", "" + (link.href) + "", true, false)) + ">" + (jade.escape((jade_interp = link.text) == null ? '' : jade_interp)) + "</a>");
}
else
{
buf.push("\n    <link class=\"text\"/>");
}
buf.push("\n  </li>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var link = $$obj[$index];

buf.push("\n  <li" + (jade.cls(["" + (link.text == current ? 'active' : '') + ""], [true])) + ">");
if (link.href)
{
buf.push("<a" + (jade.attr("href", "" + (link.href) + "", true, false)) + ">" + (jade.escape((jade_interp = link.text) == null ? '' : jade_interp)) + "</a>");
}
else
{
buf.push("\n    <link class=\"text\"/>");
}
buf.push("\n  </li>");
    }

  }
}).call(this);

buf.push("\n  <li" + (jade.cls(["" + (next ? '' : 'disabled') + ""], [true])) + ">");
if (next)
{
buf.push("<a" + (jade.attr("href", "" + (next) + "", true, false)) + "><span class=\"fa fa-caret-right\"></span></a>");
}
else
{
buf.push("<a href=\"javascript: void(0);\"><span class=\"fa fa-caret-right\"></span></a>");
}
buf.push("\n  </li>\n</ul>");
}
else
{
buf.push("\n<div class=\"no-pagination\"></div>");
};return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}